export const name = 'rendererConfiguration' as const
